import { render, staticRenderFns } from "./modal-about.vue?vue&type=template&id=2bffad7c&"
import script from "./modal-about.vue?vue&type=script&lang=js&"
export * from "./modal-about.vue?vue&type=script&lang=js&"
import style0 from "./modal-about.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modal-about.vue"
export default component.exports